var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6734 1.33576C10.5474 1.07884 10.2862 0.916016 10 0.916016C9.71388 0.916015 9.45266 1.07884 9.32665 1.33575L7.00041 6.07875L2.39079 6.75735C2.11006 6.79867 1.87669 6.99489 1.78778 7.26436C1.69888 7.53383 1.76966 7.83039 1.97068 8.03067L5.42678 11.4739L4.26863 16.5751C4.20408 16.8594 4.31016 17.1554 4.54064 17.334C4.77112 17.5126 5.08421 17.5414 5.34342 17.4079L10 15.0096L14.6566 17.4079C14.9158 17.5414 15.2289 17.5126 15.4594 17.334C15.6899 17.1554 15.796 16.8594 15.7314 16.5751L14.5733 11.4739L18.0294 8.03067C18.2304 7.83039 18.3012 7.53383 18.2123 7.26436C18.1234 6.99489 17.89 6.79867 17.6093 6.75735L12.9996 6.07875L10.6734 1.33576Z"
  })));
};
export default SvgStarFilled;